import CarbonFootprintCalculator from "./CarbonFootprintCalculator";
import BiocharUnitEconCalculator from "./BiocharUnitEconimcsCalc";
import { useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CardActions,
  Modal
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  py: 4,
  borderRadius: 4
};

export default function IkhalaCalculator() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCalculator, setSelectedCalculator] = useState(null);

  const handleModalOpen = (calculatorId) => {
    setSelectedCalculator(calculatorId);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedCalculator(null);
  };

  const items = [
    // {
    //   id: "cf-calculator",
    //   title: "Light Carbon Footprint Calculator",
    //   desc: "Calculate your high-level carbon footprint here (South Africa)",
    // },
    {
      id: "biochar-unit-calculator",
      title: "Biochar Unit Economics",
      desc: "Helps you understand the unit economics of your biochar project",
    },
  ];

  // Function to decide which calculator to display
  const renderCalculator = () => {
    switch (selectedCalculator) {
      case 'cf-calculator':
        return <CarbonFootprintCalculator />;
      case 'biochar-unit-calculator':
        return <BiocharUnitEconCalculator handleClose={handleModalClose} />;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box>
        <Typography variant="h5" component="h5">
          Calculators
        </Typography>
      </Box>
      <Grid container spacing={3} direction='row' alignItems="stretch">
        {items.map((item) => (
          <Grid item xs={3} key={item.id}>
            <Card variant='outlined' sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', py: 1, borderRadius: 4 }}>
              <CardContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', gap: 1 }}>
                  <Typography variant="h6">{item.title}</Typography>
                  <Typography color="text.secondary">{item.desc}</Typography>
                </Box>
              </CardContent>
              <CardActions>
                <Button
                  sx={{ mx: 'auto' }}
                  variant="outlined"
                  size="small"
                  onClick={() => handleModalOpen(item.id)}>
                  Open Calculator
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Modal open={isModalOpen} onClose={handleModalClose}>
        <Box sx={style}>
          {renderCalculator()}
        </Box>
      </Modal>
    </Box>
  );
}
